import { render } from "./sidemenu.html?vue&type=template&id=0eb5194e&external"
import script from "./sidemenu.vue?vue&type=script&lang=js"
export * from "./sidemenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__